module.exports = __webpack_public_path__ + "media/images/auditory_progress-1afa9780f01370006443f7b89e4a2176.svg";